import { EntitiesState } from '../entities'
import * as ModuleStates from './types'
import type { ReducersMapObject } from 'redux'
// START MODULE IMPORTS
import * as activities from './activity'
import * as agencies from './agency'
import * as artworkPages from './artworkPage'
import * as artworks from './artwork'
import * as attachments from './attachment'
import * as brands from './brand'
import * as brandThemes from './brandTheme'
import * as campaigns from './campaign'
import * as charts from './chart'
import * as comments from './comment'
import * as conversations from './conversation'
import * as currentUser from './currentUser'
import * as entities from '../entities'
import * as flipperSettings from './flipperSetting'
import * as layoutTemplates from './layoutTemplate'
import * as navigation from './navigation'
import * as providers from './provider'
import * as publicationProducts from './publicationProduct'
import * as publications from './publication'
import * as relatedEntities from './relatedEntity'
import * as roles from './role'
import * as serviceProducts from './serviceProduct'
import * as services from './service'
import * as statuses from './status'
import * as taskListItems from './taskListItem'
import * as taskLists from './taskList'
import * as taskListSections from './taskListSection'
import * as taskListTemplateItems from './taskListTemplateItem'
import * as taskListTemplates from './taskListTemplate'
import * as tags from './tag'
import * as teams from './team'
import * as templateGroups from './templateGroup'
import * as templatePagePartials from './templatePagePartial'
import * as templatePages from './templatePage'
import * as trackingLinks from './trackingLink'
import * as users from './user'
// END MODULE IMPORTS

export type RootReducerState = {
// START ROOT REDUCER STATE
  activities: ModuleStates.ActivityModuleState,
  agencies: ModuleStates.AgencyModuleState,
  artworkPages: ModuleStates.ArtworkPageModuleState,
  artworks: ModuleStates.ArtworkModuleState,
  attachments: ModuleStates.AttachmentModuleState,
  brands: ModuleStates.BrandModuleState,
  brandThemes: ModuleStates.BrandThemeModuleState,
  campaigns: ModuleStates.CampaignModuleState,
  charts: ModuleStates.ChartModuleState,
  comments: ModuleStates.CommentModuleState,
  conversations: ModuleStates.ConversationModuleState,
  currentUser: ModuleStates.CurrentUserModuleState,
  entities: EntitiesState,
  flipperSettings: ModuleStates.FlipperSettingModuleState,
  layoutTemplates: ModuleStates.LayoutTemplateModuleState,
  navigation: { showNavigation: boolean },
  providers: ModuleStates.ProviderModuleState,
  publications: ModuleStates.PublicationModuleState,
  publicationProducts: ModuleStates.PublicationProductsModuleState,
  relatedEntities: ModuleStates.RelatedEntityModuleState,
  roles: ModuleStates.RoleModuleState,
  serviceProducts: ModuleStates.ServiceProductModuleState,
  services: ModuleStates.ServiceModuleState,
  statuses: ModuleStates.StatusModuleState,
  taskListItems: ModuleStates.TaskListItemModuleState,
  taskListSections: ModuleStates.TaskListSectionModuleState,
  taskListTemplateItems: ModuleStates.TaskListTemplateItemModuleState,
  taskListTemplates: ModuleStates.TaskListTemplateModuleState,
  taskLists: ModuleStates.TaskListModuleState,
  tags: ModuleStates.TagModuleState,
  teams: ModuleStates.TeamModuleState,
  templateGroups: ModuleStates.TemplateGroupModuleState,
  templatePagePartials: ModuleStates.TemplatePagePartialModuleState,
  templatePages: ModuleStates.TemplatePageModuleState,
  trackingLinks: ModuleStates.TrackingLinkModuleState,
  users: ModuleStates.UserModuleState,
// END ROOT REDUCER STATE
}

const modules = {
// START MODULES LIST
  activities,
  agencies,
  artworks,
  artworkPages,
  attachments,
  brands,
  brandThemes,
  campaigns,
  charts,
  comments,
  conversations,
  currentUser,
  entities,
  flipperSettings,
  layoutTemplates,
  navigation,
  providers,
  publicationProducts,
  publications,
  relatedEntities,
  roles,
  serviceProducts,
  services,
  statuses,
  taskListItems,
  taskLists,
  taskListSections,
  taskListTemplateItems,
  taskListTemplates,
  tags,
  teams,
  templateGroups,
  templatePagePartials,
  templatePages,
  trackingLinks,
  users,
// END MODULES LIST
}

export const reducers = Object.keys(modules).reduce((acc, moduleKey) => {
  // @ts-expect-error TS7053
  const module = modules[moduleKey]
  // @ts-expect-error TS7053
  acc[moduleKey] = module.default

  return acc
}, {} as ReducersMapObject<RootReducerState>)

export default modules
